<template>
  <div class="wg-row wg-xs-12">
    <div class="wg-col wg-xs-12 wg-lg-7">
      <h1 class="com-anm22-page-title">{{ $anm22.strLang(lang, 'Customers', 'Clienti') }}</h1>
      <template v-if="!offline">
        <!-- Popup per l'aggiunta contatto -->
        <wg-modal
          :width="windowWidth > 700 ? '700px' : '90%'"
          v-if="showNewContactModal"
          @closeModal="showNewContactModal = !showNewContactModal"
          :portal="true"
        >
          <div
            slot="header"
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'New contact', 'Nuovo contatto') }}</div>
          <world-contact-form
            slot="body"
            :contactRef="{workOwner: project.developers[0]}"
            :ownerSelectable="false"
            :title="false"
            @closeForm="showNewContactModal = false"
            :mode="'new'"
            :afterSaveFn="newContact"
          ></world-contact-form>
        </wg-modal>
        <!-- Pagina -->
        <div class="wg-row">
          <div
            class="com-anm22-app-text-l"
          >{{ $anm22.strLang(lang, 'Type to add customers', 'Digita per aggiungere un cliente') }}</div>
          <div style="position:relative;">
            <img @click="showHelp =! showHelp" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
            <world-help-label v-if="showHelp" :position="'left'" @closeLabel="showHelp = false" :text="'Associa il progetto ad un cliente presente in Contacts o crea un nuovo cliente'"></world-help-label>
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- search bar with list -->
        <wg-search
          :placeholder="$anm22.strLang(lang, 'Contact', 'Contatto')"
          :url="'contact/getByNameInProjectDevelopers'"
          :clickFn="addCustomer"
          :canAdd="true"
          :addFn="() => { showNewContactModal = true; }"
          :filters="searchFilters"
          :attachedData="{projectId: project.idWorldProject}"
          :debounceTime="2000"
        ></wg-search>

        <!-- List of customers (ContactsContact) -->
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div
            class="wg-row"
            style="align-items:center;"
            v-for="(customer, index) in customers"
            :key="'cust-' + index"
          >
            <img
              :src="$anm22.getContactIcon(customer, $store)"
              :title="$anm22.getContactName(customer, $store)"
              class="com-anm22-app-img-fixed-height-l com-anm22-round"
              style="margin-right:5px;"
            >
            <div>
              <div
                class="com-anm22-app-text-m"
                style="font-weight:bold;"
              >{{ $anm22.getContactName(customer, $store) }}</div>
              <div class="vertical-height-div" style="height:2px;"></div>
              <div
                v-if="!offline"
                class="display-flex"
                style="align-items:center;cursor:pointer;"
                @click="removeCustomer(customer)"
              >
                <img
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteRed')"
                >
                <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
              </div>
            </div>
            <a :href="'https://contacts.anm22.it/contact/' + customer.idContactsContact">
              <img
                :src="$anm22.icons.getWorldIcon('openApp')"
                :title="$anm22.strLang(lang, 'Open in Contacts', 'Apri in Contacts')"
                class="com-anm22-app-img-fixed-height-m"
                style="margin-left:20px;"
              >
            </a>
            <div class="vertical-height-div" style="height:10px;"></div>
          </div>
        </div>

        <template v-if="project.developers.includes(965)">
          <!-- Paglierani - Gestione agenti e subagenti -->
          <h2 class="com-anm22-page-title">{{ $anm22.strLang(lang, 'Agent', 'Agente') }}</h2>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Type to add agent', 'Digita per aggiungere un agente') }}</div>
            <div style="position:relative;">
              <img @click="showHelp1 =! showHelp1" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
              <world-help-label v-if="showHelp1" :position="'left'" @closeLabel="showHelp1 = false" :text="'Associa il progetto ad un agente presente in Contacts'"></world-help-label>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <wg-search
            :placeholder="$anm22.strLang(lang, 'Contact', 'Contatto')"
            :url="'contact/getByNameInProjectDevelopers'"
            :clickFn="addAgent"
            :canAdd="true"
            :addFn="() => { showNewContactModal = true; }"
            :filters="searchFilters"
            :attachedData="{projectId: project.idWorldProject}"
            :debounceTime="2000"
          ></wg-search>

          <!-- Agent (ContactsContact) -->
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <div
              class="wg-row"
              style="align-items:center;"
              v-if="agent"
            >
              <img
                :src="$anm22.getContactIcon(agent, $store)"
                :title="$anm22.getContactName(agent, $store)"
                class="com-anm22-app-img-fixed-height-l com-anm22-round"
                style="margin-right:5px;"
              >
              <div>
                <div
                  class="com-anm22-app-text-m"
                  style="font-weight:bold;"
                >{{ $anm22.getContactName(agent, $store) }}</div>
                <div class="vertical-height-div" style="height:2px;"></div>
                <div
                  v-if="!offline"
                  class="display-flex"
                  style="align-items:center;cursor:pointer;"
                  @click="removeAgent(agent)"
                >
                  <img
                    class="com-anm22-app-img-fixed-height-s"
                    :src="$anm22.icons.getWorldIcon('deleteRed')"
                  >
                  <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                  <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
                </div>
              </div>
              <a :href="'https://contacts.anm22.it/contact/' + agent.idContactsContact">
                <img
                  :src="$anm22.icons.getWorldIcon('openApp')"
                  :title="$anm22.strLang(lang, 'Open in Contacts', 'Apri in Contacts')"
                  class="com-anm22-app-img-fixed-height-m"
                  style="margin-left:20px;"
                >
              </a>
              <div class="vertical-height-div" style="height:10px;"></div>
            </div>
          </div>

          <!-- Subagent -->
          <h2 class="com-anm22-page-title">{{ $anm22.strLang(lang, 'Subagent', 'Subagente') }}</h2>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-l"
            >{{ $anm22.strLang(lang, 'Type to add subagnet', 'Digita per aggiungere un subagente') }}</div>
            <div style="position:relative;">
              <img @click="showHelp2 =! showHelp2" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
              <world-help-label v-if="showHelp2" :position="'left'" @closeLabel="showHelp2 = false" :text="'Associa il progetto ad un subagente presente in Contacts'"></world-help-label>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <wg-search
            :placeholder="$anm22.strLang(lang, 'Contact', 'Contatto')"
            :url="'contact/getByNameInProjectDevelopers'"
            :clickFn="addSubagent"
            :canAdd="true"
            :addFn="() => { showNewContactModal = true; }"
            :filters="searchFilters"
            :attachedData="{projectId: project.idWorldProject}"
            :debounceTime="2000"
          ></wg-search>

          <!-- List of subagents (ContactsContact) -->
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <div
              class="wg-row"
              style="align-items:center;"
              v-if="subagent"
            >
              <img
                :src="$anm22.getContactIcon(subagent, $store)"
                :title="$anm22.getContactName(subagent, $store)"
                class="com-anm22-app-img-fixed-height-l com-anm22-round"
                style="margin-right:5px;"
              >
              <div>
                <div
                  class="com-anm22-app-text-m"
                  style="font-weight:bold;"
                >{{ $anm22.getContactName(subagent, $store) }}</div>
                <div class="vertical-height-div" style="height:2px;"></div>
                <div
                  v-if="!offline"
                  class="display-flex"
                  style="align-items:center;cursor:pointer;"
                  @click="removeSubagent(subagent)"
                >
                  <img
                    class="com-anm22-app-img-fixed-height-s"
                    :src="$anm22.icons.getWorldIcon('deleteRed')"
                  >
                  <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                  <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
                </div>
              </div>
              <a :href="'https://contacts.anm22.it/contact/' + subagent.idContactsContact">
                <img
                  :src="$anm22.icons.getWorldIcon('openApp')"
                  :title="$anm22.strLang(lang, 'Open in Contacts', 'Apri in Contacts')"
                  class="com-anm22-app-img-fixed-height-m"
                  style="margin-left:20px;"
                >
              </a>
              <div class="vertical-height-div" style="height:10px;"></div>
            </div>
          </div>
        </template>
        
      </template>
      
    </div>
    <div class="wg-col wg-xs-none wg-lg-5 project-manage-help-box">
      <img :src="$anm22.icons.getWorldIcon('workContact')" />
      <div>
        <strong>{{$anm22.strLang(lang, 'Add project customer', 'Imposta il cliente')}}</strong><br />
        {{$anm22.strLang(lang, '', 'Inserisci il cliente del progetto per poter associare la comessa al suo profilo su Contacts.')}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldContactForm from "../../../../../../world/spa/components/WorldContactForm.vue";
import WorldHelpLabel from "../../../../../../world/spa/components/WorldHelpLabel.vue";

export default {
  props: {
    data: Object
  },
  data() {
    return {
      showHelp: false,
      showHelp1: false,
      showHelp2: false,
      showNewContactModal: false,
      agent: null,
      subagent: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      windowWidth: state => state.windowWidth,
      offline: state => state.offline.isOffline
    }),
    project() {
      return this.$store.getters["projects/get"](
        this.data.project.idWorldProject
      );
    },
    customers() {
      let result = [];
      this.project.customers.forEach(contactId => {
        const contact = this.$store.getters["contacts/get"](contactId);
        if (contact) {
          result.push(contact);
        }
      });
      return result;
    },
    searchFilters() {
      return [contact => !this.project.customers.includes(contact.id)];
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    }
  },
  methods: {
    newContact(id) {
      this.showNewContactModal = false;
      this.addCustomer(id);
    },
    addCustomer(customerId) {
      this.$http
        .post("/project/addCustomer", {
          projectId: this.project.idWorldProject,
          contactId: customerId
        }, {
          withCredentials: true
        })
        .then(response => {
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            }),
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            })
          ]);
        })
        .catch(error => console.log(error));
    },
    removeCustomer(contact) {
      this.$http
        .post("/project/removeCustomer", {
          projectId: this.project.idWorldProject,
          contactId: contact.idContactsContact
        }, {
          withCredentials: true
        })
        .then(response => {
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            }),
            this.$store.dispatch("contacts/delete", {
              vlf: this.$vlf("contacts"),
              obj: contact
            })
          ]);
        })
        .catch(error => {});
    },
    getAgent() {
      this.$http
        .get("/paglierani/getAgent?projectId=" + this.project.idWorldProject)
        .then(response => {
          return Promise.all([
            this.agent = response.data.agent
          ]);
        })
        .catch(error => console.log(error));
    },
    getSubagent() {
      this.$http
        .get("/paglierani/getSubagent?projectId=" + this.project.idWorldProject)
        .then(response => {
          return Promise.all([
            this.subagent = response.data.subagent
          ]);
        })
        .catch(error => console.log(error));
    },
    addAgent(customerId) {
      this.$http
        .post("/paglierani/addAgent", {
          projectId: this.project.idWorldProject,
          contactId: customerId
        }, {
          withCredentials: true
        })
        .then(response => {
          this.getAgent();
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            }),
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            })
          ]);
        })
        .catch(error => console.log(error));
    },
    removeAgent(contact) {
      this.$http
        .post("/paglierani/removeAgent", {
          projectId: this.project.idWorldProject,
          contactId: contact.idContactsContact
        }, {
          withCredentials: true
        })
        .then(response => {
          this.agent = null;
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            }),
            this.$store.dispatch("contacts/delete", {
              vlf: this.$vlf("contacts"),
              obj: contact
            })

          ]);
        })
        .catch(error => {});
    },
    addSubagent(customerId) {
      this.$http
        .post("/paglierani/addSubagent", {
          projectId: this.project.idWorldProject,
          contactId: customerId
        }, {
          withCredentials: true
        })
        .then(response => {
          this.getSubagent();
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            }),
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            })
          ]);
        })
        .catch(error => console.log(error));
    },
    removeSubagent(contact) {
      this.$http
        .post("/paglierani/removeSubagent", {
          projectId: this.project.idWorldProject,
          contactId: contact.idContactsContact
        }, {
          withCredentials: true
        })
        .then(response => {
          this.subagent = null;
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            }),
            this.$store.dispatch("contacts/delete", {
              vlf: this.$vlf("contacts"),
              obj: contact
            })
          ]);
        })
        .catch(error => {});
    },
    // getPricingPerm(pricing) {
    //   return this.customer.idWorldWork !== pricing.customer
    //     && (this.userPermission <= 3 || (pricing.supplierAccountable && pricing.supplierAccountable === this.user.idWorldUser));
    // },
    loadData() {
      Promise.all([
        this.$store.dispatch("projects/load", this.$vlf("projects")),
        this.$store.dispatch("contacts/load", this.$vlf("contacts"))
      ])
        .then(() => {
          this.$Progress.finish();
        })
        .catch(error => console.log(error));
    }
  },
  created() {
    this.loadData();
    this.$http
      .get("project/customer?idProject=" + this.$route.params.id)
      .then(response => {
        Promise.all([
          this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: response.data.projects
          }),
          this.$store.dispatch("contacts/update", {
            vlf: this.$vlf("contacts"),
            objs: response.data.contacts
          })
        ])
          .then(result => {})
          .catch(error => {
            console.log(error);
          });
      })
      .catch(error => console.log(error));
    if (this.project.developers.includes(965)) {
      this.getAgent();
      this.getSubagent();
    }
  },
  components: {
    WorldContactForm,
    WorldHelpLabel
  }
};
</script>

<style lang="scss" scoped>
</style>
